export default __webpack_public_path__ + "static/media/menu_icon_settings.be3eeef1.svg";